import ShowMoreText from 'react-show-more-text';

import useStyles from './styles';

export const ReadMore = ({
  children: text,
  lines = 2,
  className,
}: {
  children: string;
  lines?: number;
  className?: string;
}) => {
  const classes = useStyles();

  return (
    <ShowMoreText
      lines={lines}
      more="Read more"
      less="Read less"
      className={[classes.showMoreTextContent, className].filter(Boolean).join(' ')}
      anchorClass={classes.showMoreTextAnchor}
      expanded={false}
      truncatedEndingComponent={'... '}
    >
      {text}
    </ShowMoreText>
  );
};
